export default "__VITE_ASSET__C8Q5UM9T__"